<template>
  <span class="tw:flex tw:flex-col tw:gap-2">
    <LeadInput
      v-model="number"
      type="tel"
      autocomplete="tel"
      :label="$t('registration.profile.mobile_correct')"
      :placeholder="$t('registration.account.mobile_placeholder')"
      :errors="error"
      :data-testid="`${testidPrefix}-input`" />
    <span class="tw:flex tw:items-center tw:gap-3">
      <LeadButton variant="primary" :loading="loading" :data-testid="`${testidPrefix}-save`" @click="emit('save')">
        {{ $t('registration.profile.mobile_save') }}
      </LeadButton>
      <LeadButton
        v-if="cancellable"
        variant="link"
        :disabled="loading"
        :data-testid="`${testidPrefix}-cancel`"
        @click="emit('cancel')">
        {{ $t('registration.profile.mobile_cancel') }}
      </LeadButton>
    </span>
  </span>
</template>

<script setup lang="ts">
import LeadButton from '@/components/lead-design/LeadButton.vue';
import LeadInput from '@/components/lead-design/LeadInput.vue';

interface Props {
  testidPrefix: string;
  error?: string;
  loading?: boolean;
  /** false when there is no number to go back to */
  cancellable?: boolean;
}

withDefaults(defineProps<Props>(), { error: '', loading: false, cancellable: true });

const emit = defineEmits<{ save: []; cancel: [] }>();

const number = defineModel<string>({ required: true });
</script>
